import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import React, { FC } from "react";

interface CardProps {
  skill: { id: string; title: string; image: ImageDataLike };
}
const ToolkitCard: FC<CardProps> = ({ skill }) => {
  const imageUrl = getImage(skill.image);
  return (
    <div
      key={skill.id}
      className="w-20 h-24 my-3 xl:my-6 transform hover:scale-110 transition duration-300 cursor-pointer rounded-md border border-gray-400 shadow-xl flex flex-col items-center justify-evenly"
    >
      <h6 className="text-xs text-center font-custom uppercase font-semibold">
        {skill.title}
      </h6>
      <GatsbyImage
        image={imageUrl}
        loading="eager"
        alt="Home"
        className="w-10 h-8 object-cover"
      />
    </div>
  );
};

export default ToolkitCard;
